
export default function AppObjectFieldObjectOwner({ field, value }) {
  console.log(`AppObjectFieldObjectOwner rendered: ${field.name}`)

  return (
    <div>
      {value}
    </div>
  )
}
